import { defineMessages } from 'react-intl-next';
const messages = defineMessages({
  newLozenge: {
    id: 'fabric.atlassianSwitcher.newLozenge',
    defaultMessage: 'New',
    description: 'The lozenge text for a lozenge indicating a new switcher item'
  },
  tryLozenge: {
    id: 'fabric.atlassianSwitcher.tryLozenge',
    defaultMessage: 'Try',
    description: 'Alternative lozenge text for a lozenge indicating a new switcher item'
  },
  sites: {
    id: 'fabric.atlassianSwitcher.sites',
    defaultMessage: '{productName} {numSites, plural, one {site} other {sites}}',
    description: 'The text of a toggle showing or hiding more site options'
  },
  skeletonLoaderAriaLabel: {
    id: 'fabric.atlassianSwitcher.skeletonLoaderAriaLabel',
    defaultMessage: 'The App Switcher is loading',
    description: 'The aria-label for the app switcher skeleton loader primative'
  }
});
export default messages;